import { useState } from 'react';

export default function GallerySection() {
  const [selectedImage, setSelectedImage] = useState<number | null>(null);

  const galleryImages = [
    {
      src: "https://static.readdy.ai/image/d7e77f925f0119a01fe5d8699c3ff655/7abc0a49f9a15d2c91306b3760d6dc51.jpeg",
      alt: "Retrato familiar con vestidos elegantes",
      category: "Familiar"
    },
    {
      src: "https://static.readdy.ai/image/d7e77f925f0119a01fe5d8699c3ff655/0ceeb4d072bfa1afdeed63bcda02d024.jpeg",
      alt: "Retrato familiar con elegancia",
      category: "Familiar"
    },
    {
      src: "https://static.readdy.ai/image/d7e77f925f0119a01fe5d8699c3ff655/bc72e6fffd2d1fe83c39f4cd7beaccff.jpeg",
      alt: "Retrato familiar en estudio",
      category: "Familiar"
    },
    {
      src: "https://static.readdy.ai/image/d7e77f925f0119a01fe5d8699c3ff655/054a89b702dd99a435291e95a59e238c.jpeg",
      alt: "Retratos infantiles navideños",
      category: "Infantil"
    },
    {
      src: "https://static.readdy.ai/image/d7e77f925f0119a01fe5d8699c3ff655/5ca7f2b168b78e19243e3a59083aadc9.jpeg",
      alt: "Sesión Familiar",
      category: "Familiar"
    },
    {
      src: "https://static.readdy.ai/image/d7e77f925f0119a01fe5d8699c3ff655/d6fbf97d6cff4aaf268026231efd5afe.jpeg",
      alt: "Christmas Village Magic",
      category: "Familiar"
    },
    {
      src: "https://static.readdy.ai/image/d7e77f925f0119a01fe5d8699c3ff655/8c2760ada0a6d27c2e992dd782f5b7b0.jpeg",
      alt: "The Red Door Christmas",
      category: "Familiar"
    },
    {
      src: "https://static.readdy.ai/image/d7e77f925f0119a01fe5d8699c3ff655/d56c53051caf385b37bcd583e83a7c36.jpeg",
      alt: "Momento mágico navideño",
      category: "Infantil"
    }
  ];

  return (
    <section className="py-12 sm:py-16 md:py-20 lg:py-24 xl:py-28 px-3 sm:px-4 md:px-6 lg:px-8 relative bg-black">
      {/* Fondo estrellado */}
      <div className="absolute inset-0">
        {[...Array(35)].map((_, i) => (
          <div
            key={i}
            className="absolute animate-pulse opacity-20"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${3 + Math.random() * 2}s`
            }}
          >
            <div className="w-0.5 h-0.5 rounded-full bg-gold-500"></div>
          </div>
        ))}
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Título de la sección */}
        <div className="text-center mb-8 sm:mb-12 md:mb-16 lg:mb-20">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold mb-3 sm:mb-4 md:mb-6 lg:mb-8 leading-tight font-serif text-gold-500 px-2">
            Galería de Momentos
          </h2>
          <div className="w-12 sm:w-16 md:w-20 lg:w-24 xl:w-32 h-px mx-auto mb-4 sm:mb-6 md:mb-8 lg:mb-10 bg-gradient-to-r from-transparent via-gold-500 to-transparent"></div>
          <p className="text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl text-gray-300 max-w-4xl mx-auto leading-relaxed px-3 sm:px-4 font-sans">
            Así vivimos la magia de la Navidad en años anteriores…
            <br className="hidden sm:block" />
            Este 2025, dos escenarios completamente nuevos te esperan:
            <br className="hidden sm:block" />
            <span className="text-gold-400 font-medium">Christmas Village Magic</span> • <span className="text-gold-400 font-medium">The Red Door Christmas</span>
          </p>
        </div>

        {/* Grid de galería - Masonry layout para mantener proporciones originales */}
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-3 sm:gap-4 md:gap-6 lg:gap-8 space-y-3 sm:space-y-4 md:space-y-6 lg:space-y-8">
          {galleryImages.map((image, index) => (
            <div 
              key={index} 
              className="group relative overflow-hidden rounded-xl sm:rounded-2xl lg:rounded-3xl cursor-pointer border-2 border-gold-500/30 hover:border-gold-500/60 transition-all duration-300 touch-manipulation break-inside-avoid"
              onClick={() => setSelectedImage(index)}
              style={{
                boxShadow: '0 0 15px rgba(213, 171, 76, 0.2)'
              }}
            >
              <div className="relative">
                <img 
                  src={image.src}
                  alt={image.alt}
                  className="w-full h-auto object-contain group-hover:scale-105 sm:group-hover:scale-110 transition-transform duration-500 sm:duration-700"
                  loading="lazy"
                />
                
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                
                {/* Contenido del overlay */}
                <div className="absolute inset-0 flex flex-col justify-end p-3 sm:p-4 md:p-6 lg:p-8 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="transform translate-y-2 sm:translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                    <div className="flex items-center space-x-2 mb-1 sm:mb-2 lg:mb-3">
                      <span className={`px-2 sm:px-3 py-0.5 sm:py-1 rounded-full text-xs sm:text-sm lg:text-base font-medium font-sans ${
                        image.category === 'Familiar' ? 'bg-gold-500/20 border border-gold-500/50 text-gold-400' :
                        image.category === 'Infantil' ? 'bg-cherry-500/20 border border-cherry-500/50 text-cherry-400' :
                        image.category === 'Pareja' ? 'bg-pine-500/20 border border-pine-500/50 text-pine-400' :
                        'bg-gold-500/20 border border-gold-500/50 text-gold-400'
                      }`}>
                        {image.category}
                      </span>
                    </div>
                    <p className="text-white text-xs sm:text-sm md:text-base lg:text-lg font-medium font-sans">{image.alt}</p>
                  </div>
                </div>

                {/* Icono de zoom */}
                <div className="absolute top-2 sm:top-3 md:top-4 lg:top-6 right-2 sm:right-3 md:right-4 lg:right-6 w-6 h-6 sm:w-8 sm:h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 bg-black/50 backdrop-blur-sm rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <i className="ri-zoom-in-line text-white text-xs sm:text-sm md:text-base lg:text-lg"></i>
                </div>

                {/* Marco dorado decorativo */}
                <div className="absolute inset-0 pointer-events-none">
                  {/* Esquinas decorativas */}
                  <div className="absolute top-1 sm:top-2 md:top-3 lg:top-4 left-1 sm:left-2 md:left-3 lg:left-4 w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 lg:w-6 lg:h-6 border-l-2 border-t-2 border-gold-500 opacity-60"></div>
                  <div className="absolute top-1 sm:top-2 md:top-3 lg:top-4 right-1 sm:right-2 md:right-3 lg:right-4 w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 lg:w-6 lg:h-6 border-r-2 border-t-2 border-gold-500 opacity-60"></div>
                  <div className="absolute bottom-1 sm:bottom-2 md:bottom-3 lg:bottom-4 left-1 sm:left-2 md:left-3 lg:left-4 w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 lg:w-6 lg:h-6 border-l-2 border-b-2 border-gold-500 opacity-60"></div>
                  <div className="absolute bottom-1 sm:bottom-2 md:bottom-3 lg:bottom-4 right-1 sm:right-2 md:right-3 lg:right-4 w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 lg:w-6 lg:h-6 border-r-2 border-b-2 border-gold-500 opacity-60"></div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Modal de imagen ampliada - Completamente responsivo */}
        {selectedImage !== null && (
          <div className="fixed inset-0 bg-black/90 backdrop-blur-sm z-50 flex items-center justify-center p-2 sm:p-4" onClick={() => setSelectedImage(null)}>
            <div className="relative max-w-6xl max-h-[95vh] sm:max-h-[90vh] w-full">
              <button 
                onClick={() => setSelectedImage(null)}
                className="absolute -top-8 sm:-top-12 lg:-top-16 right-0 w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white/20 transition-colors cursor-pointer z-10"
              >
                <i className="ri-close-line text-lg sm:text-xl lg:text-2xl"></i>
              </button>
              
              <div className="relative rounded-xl sm:rounded-2xl lg:rounded-3xl overflow-hidden border-2 sm:border-4 border-gold-500/60"
                style={{
                  boxShadow: '0 0 30px rgba(213, 171, 76, 0.5)'
                }}
              >
                <img 
                  src={galleryImages[selectedImage].src}
                  alt={galleryImages[selectedImage].alt}
                  className="w-full h-full max-h-[80vh] sm:max-h-[85vh] object-contain"
                />
                
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3 sm:p-4 md:p-6 lg:p-8">
                  <div className="flex items-center space-x-2 sm:space-x-3 lg:space-x-4 mb-1 sm:mb-2 lg:mb-3">
                    <span className={`px-2 sm:px-3 lg:px-4 py-0.5 sm:py-1 lg:py-2 rounded-full text-xs sm:text-sm lg:text-base font-medium font-sans ${
                      galleryImages[selectedImage].category === 'Familiar' ? 'bg-gold-500/20 border border-gold-500/50 text-gold-400' :
                      galleryImages[selectedImage].category === 'Infantil' ? 'bg-cherry-500/20 border border-cherry-500/50 text-cherry-400' :
                      galleryImages[selectedImage].category === 'Pareja' ? 'bg-pine-500/20 border border-pine-500/50 text-pine-400' :
                      'bg-gold-500/20 border border-gold-500/50 text-gold-400'
                    }`}>
                      {galleryImages[selectedImage].category}
                    </span>
                  </div>
                  <p className="text-white text-sm sm:text-base md:text-lg lg:text-xl font-medium font-sans">{galleryImages[selectedImage].alt}</p>
                </div>

                {/* Marco dorado decorativo en modal */}
                <div className="absolute inset-0 pointer-events-none">
                  <div className="absolute top-2 sm:top-4 lg:top-6 left-2 sm:left-4 lg:left-6 w-4 h-4 sm:w-6 sm:h-6 lg:w-8 lg:h-8 xl:w-10 xl:h-10 border-l-2 sm:border-l-3 border-t-2 sm:border-t-3 border-gold-500 opacity-80"></div>
                  <div className="absolute top-2 sm:top-4 lg:top-6 right-2 sm:right-4 lg:right-6 w-4 h-4 sm:w-6 sm:h-6 lg:w-8 lg:h-8 xl:w-10 xl:h-10 border-r-2 sm:border-r-3 border-t-2 sm:border-t-3 border-gold-500 opacity-80"></div>
                  <div className="absolute bottom-2 sm:bottom-4 lg:bottom-6 left-2 sm:left-4 lg:left-6 w-4 h-4 sm:w-6 sm:h-6 lg:w-8 lg:h-8 xl:w-10 xl:h-10 border-l-2 sm:border-l-3 border-b-2 sm:border-b-3 border-gold-500 opacity-80"></div>
                  <div className="absolute bottom-2 sm:bottom-4 lg:bottom-6 right-2 sm:right-4 lg:right-6 w-4 h-4 sm:w-6 sm:h-6 lg:w-8 lg:h-8 xl:w-10 xl:h-10 border-r-2 sm:border-r-3 border-b-2 sm:border-b-3 border-gold-500 opacity-80"></div>
                </div>
              </div>

              {/* Navegación - Adaptada para móviles */}
              <button 
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedImage(selectedImage > 0 ? selectedImage - 1 : galleryImages.length - 1);
                }}
                className="absolute left-1 sm:left-2 md:left-4 lg:left-6 top-1/2 transform -translate-y-1/2 w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 lg:w-16 lg:h-16 bg-black/50 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-black/70 transition-colors cursor-pointer touch-manipulation"
              >
                <i className="ri-arrow-left-line text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl"></i>
              </button>
              
              <button 
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedImage(selectedImage < galleryImages.length - 1 ? selectedImage + 1 : 0);
                }}
                className="absolute right-1 sm:right-2 md:right-4 lg:right-6 top-1/2 transform -translate-y-1/2 w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 lg:w-16 lg:h-16 bg-black/50 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-black/70 transition-colors cursor-pointer touch-manipulation"
              >
                <i className="ri-arrow-right-line text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl"></i>
              </button>

              {/* Indicador de posición */}
              <div className="absolute bottom-2 sm:bottom-4 left-1/2 transform -translate-x-1/2 bg-black/50 backdrop-blur-sm rounded-full px-2 sm:px-3 py-1 sm:py-2">
                <span className="text-white text-xs sm:text-sm font-sans">
                  {selectedImage + 1} / {galleryImages.length}
                </span>
              </div>
            </div>
          </div>
        )}

        {/* CTA */}
        <div className="text-center mt-8 sm:mt-12 md:mt-16 lg:mt-20">
          <button 
            onClick={() => {
              const servicesSection = document.getElementById('services-section');
              if (servicesSection) {
                servicesSection.scrollIntoView({ 
                  behavior: 'smooth',
                  block: 'start'
                });
              } else {
                // Fallback: scroll to services section by finding it
                const servicesElement = document.querySelector('[id="services-section"]');
                if (servicesElement) {
                  servicesElement.scrollIntoView({ 
                    behavior: 'smooth',
                    block: 'start'
                  });
                }
              }
            }}
            className="text-black font-semibold py-2.5 sm:py-3 md:py-4 lg:py-5 px-4 sm:px-6 md:px-8 lg:px-10 rounded-lg sm:rounded-xl lg:rounded-2xl transition-all duration-300 whitespace-nowrap cursor-pointer bg-gradient-to-r from-gold-500 to-gold-600 hover:from-gold-600 hover:to-gold-700 font-sans text-sm sm:text-base md:text-lg lg:text-xl touch-manipulation"
          >
            Ver Espacios Disponibles
          </button>
        </div>

      </div>
    </section>
  );
}
